import React, { useState } from "react";
import { Fab, Tooltip } from "@material-ui/core";
import ExportIcon from 'mdi-react/VideoIcon';
import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_getBuildingURL,
	_qaThreadMap,
	_formatUnitNumber,
	_slugifyText,
	_formatNumberDecimal
} from '../../../../shared/helpers/utils';
import{
	_axiosCall
} from '../../../../shared/helpers/apicalls';
const apiUrl = process.env.API_ROOT;

const HeygenExportButton = ({ iframeRef, user, avatar_id, voice_id, callback_id, className, disabled, setAIInProgress, snackOpen, toggleModal, reportItem }) => {
  const [progress, setProgress] = useState("Generate AI Video");

  const handleExport = async (e) => {
	e.preventDefault();
	setAIInProgress(true);
	setProgress("Submitting...");
  
	try {
	  const iframe = iframeRef.current;
	  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  
	  const scriptParagraphs = iframeDoc.querySelectorAll("p.copy-script");
	  const titles = iframeDoc.querySelectorAll("div.video-title");
  
	  const combinedText = Array.from(scriptParagraphs)
		.map(function (p) {
		  return p.textContent.trim();
		})
		.join("\n\n");
  
	  const title = Array.from(titles)
		.map(function (t) {
		  return t.textContent.trim();
		})
		.join(" - ");
  
	  if (!combinedText) throw new Error("No content found to export.");
  
	  var payloadMapData = {};
  
	  if (reportItem && reportItem.payloadMap) {
		var keys = Object.keys(reportItem.payloadMap);
		for (var i = 0; i < keys.length; i++) {
		  var key = keys[i];
		  var config = reportItem.payloadMap[key];
		  var dataMap = config.data_map;
  
		  if (!dataMap || !dataMap.selector) continue;
  
		  var element = iframeDoc.querySelector(dataMap.selector);
		  if (!element) continue;
  
		  // Deep clone config to avoid mutating the original
		  var cloned = JSON.parse(JSON.stringify(config));
  
		  if (cloned.type === "text" && dataMap.type === "textContent") {
			cloned.properties.content = element.textContent.trim();
		  } else if (cloned.type === "image" && dataMap.type === "attr" && dataMap.attr === "src") {
			cloned.properties.url = element.getAttribute("src");
		  }
  
		  // Remove data_map after processing
		  delete cloned.data_map;
  
		  payloadMapData[key] = cloned;
		}
	  }
  
	  var payload = {
		avatar_id: avatar_id ? avatar_id : "Abigail_expressive_2024112501",
		title: title ? title : null,
		voice_id: voice_id ? voice_id : "c8e176c17f814004885fd590e03ff99f",
		input_text: combinedText,
		callback_id: callback_id ? callback_id : "123",
		user: user,
		variables: payloadMapData,
		template_id: reportItem.template_id ? reportItem.template_id : null
	  };
  console.log(payload);
  	  var endpoint = apiUrl + "/videoai/create";
	  if(reportItem && reportItem.template_id){
		  endpoint = apiUrl + "/videoai/create-from-template";
	  }
	  var userData = {
		url: endpoint,
		method: "post",
		query: payload
	  };
  
	  await _axiosCall(userData);
	  setProgress("Submitted!");
	} catch (err) {
	  console.error("Export failed:", err);
	  setProgress("Failed to export.");
	} finally {
	  setTimeout(function () {
		snackOpen("Your AI video is being generated—we’ll email you when it’s ready!");
		setAIInProgress(false);
		setProgress("Generate AI Video");
		toggleModal();
	  }, 1000);
	}
  };


  return (
	<Tooltip title="Generate AI video using this script">
	  <Fab
		variant="extended"
		size="medium"
		color="secondary"
		aria-label="export"
		className={className}
		onClick={handleExport}
		disabled={disabled}
		style={{marginRight:10}}
	  >
		<ExportIcon style={{ marginRight: 5 }} />
		{progress}
	  </Fab>
	</Tooltip>
  );
};

export default HeygenExportButton;
